import { SummarizerConfig } from '../../types/summarizer';

export const googleDocsSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'google-docs-summarizer',
  title: 'Google Docs Summarizer',
  description: 'Summarize Google Docs documents with AI-powered analysis',
  version: '1.0.0',

  // Categorization
  category: 'document',
  tags: ['google-docs', 'documents', 'collaboration', 'cloud'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Google Docs are accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter Google Docs share link',
      validation: /docs\.google\.com\/document/,
      examples: [
        'https://docs.google.com/document/d/1ABC123.../edit',
        'https://docs.google.com/document/d/1XYZ789.../edit?usp=sharing',
      ],
      helpText: 'Share link must have public access or be viewable by anyone with the link.',
      showExamples: true,
      showHelpText: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
    repurpose: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'google-docs',
    timeout: 90000, // 90 seconds for document processing
  },

  // UI customization (Level 1: Basic styling)
  ui: {
    // Basic styling
    primaryColor: '#4285f4',
    secondaryColor: '#34a853',
    icon: '📝',
    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0, // No file size limit for URLs
    allowedDomains: ['docs.google.com'],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
